import {apiUrl} from '../utils/constants';
import {DELETE} from './api.service.wrapper';

export const DeleteAttachment = async (id) => {
    const response = await DELETE(apiUrl.remove_attachment, id);
    return response;
}

